var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.GetStartedLayout,
    {
      ref: "layout",
      attrs: {
        errors: _vm.errors,
        noContainer: "",
        fluid: "",
        breadcrumbs: _setup.breadcrumbs,
        guest: _vm.client,
        child: _vm.child,
        review: _vm.review,
        hideNavOnScroll: _setup.breakpoint.xs,
        location: _vm.client.location,
      },
      scopedSlots: _vm._u([
        {
          key: "toggleFilter",
          fn: function () {
            return [
              _vm.shoppingCartItems
                ? _c(
                    "v-btn",
                    {
                      attrs: { icon: "", outlined: "", color: "white" },
                      on: {
                        click: function ($event) {
                          _vm.$inertia.get(_vm.route("checkout.show"))
                        },
                      },
                    },
                    [
                      _c(
                        "v-badge",
                        {
                          attrs: {
                            content: _vm.shoppingCartItems,
                            color: "secondary",
                            overlap: "",
                            bordered: "",
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "white--text" }, [
                            _vm._v("shopping_cart"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "v-col",
        {
          staticClass: "white--text px-0 mx-auto",
          class: { "mt-4": _setup.tinyScreen },
          attrs: { cols: "12", sm: "11", md: "10", lg: "8", xl: "6" },
        },
        [
          _c(
            "v-card",
            {
              staticClass: "mx-auto",
              class: {
                "soli-round": _setup.breakpoint.smAndUp,
                "py-4": _setup.breakpoint.xs,
              },
              attrs: { tile: _setup.breakpoint.xs },
            },
            [
              _c("v-container", { attrs: { fluid: "" } }, [
                _c(
                  "div",
                  {
                    staticClass: "grid grid-cols-1",
                    class: { "grid-cols-2 gap-4": _setup.breakpoint.mdAndUp },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex flex-col" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "flex shrink",
                            class: {
                              " pt-4": _setup.breakpoint.smAndUp,
                              "px-4": !_setup.tinyScreen,
                            },
                          },
                          [
                            !_setup.tinyScreen
                              ? _c("v-img", {
                                  staticClass: "soli-round my-auto",
                                  class: {
                                    "shrink ":
                                      _setup.breakpoint.mdAndUp ||
                                      _setup.showFullDescription,
                                  },
                                  attrs: {
                                    contain: "",
                                    height: 96,
                                    width: 96,
                                    src: "/junior-tiny.webp",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col justify-center" },
                              [
                                _c(
                                  "v-card-subtitle",
                                  {
                                    staticClass:
                                      "soli-grey !font-semibold py-0",
                                  },
                                  [_vm._v("6 months - 5 years")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-card-title",
                                  {
                                    staticClass:
                                      "font-weight-bold accent--text pt-0 pb-0",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    Musicologie Junior\n                                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _setup.breakpoint.smAndDown &&
                                !_setup.showFullDescription
                                  ? _c(
                                      "v-card-text",
                                      { staticClass: "soli-grey py-0" },
                                      [
                                        _c("span", {
                                          staticClass: "line-clamp-1",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _setup.description
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              text: "",
                                              "x-small": "",
                                              rounded: "",
                                              color: "accent",
                                              outlined: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _setup.showFullDescription =
                                                  !_setup.showFullDescription
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "More\n                                    "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _setup.breakpoint.mdAndUp || _setup.showFullDescription
                          ? _c("v-card-text", { staticClass: "soli-grey" }, [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_setup.description),
                                },
                              }),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "px-4" },
                          [
                            _setup.breakpoint.smAndDown &&
                            _setup.showFullDescription
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      text: "",
                                      "x-small": "",
                                      rounded: "",
                                      outlined: "",
                                      color: "accent",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _setup.showFullDescription =
                                          !_setup.showFullDescription
                                      },
                                    },
                                  },
                                  [_vm._v("Less\n                            ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-col desktop-scroll overflow-y-auto px-2",
                      },
                      [
                        _c(
                          "v-card-title",
                          {
                            staticClass:
                              "soli-grey pt-4 pb-2 px-1 font-weight-bold",
                          },
                          [_vm._v("Upcoming Classes")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _setup.loading
                              ? _c("v-skeleton-loader", {
                                  staticClass: "w-full",
                                  attrs: {
                                    type: "list-item-avatar-three-line@6",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_setup.loading && !_setup.classes.length
                              ? _c("div", { staticClass: "soli-grey px-1.5" }, [
                                  _vm._v(
                                    "\n                                Sorry! All of our classes are full. Contact\n                                us to join our waitlist!\n                            "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _setup.classes.length && !_setup.loading
                              ? _c(
                                  "v-list",
                                  { staticClass: "py-0" },
                                  [
                                    _c(
                                      "v-list-item-group",
                                      { staticClass: "flex flex-col divide-y" },
                                      _vm._l(
                                        _setup.classes,
                                        function (item, idx) {
                                          return _c(
                                            "div",
                                            { key: idx },
                                            [
                                              _c(
                                                "v-list-item",
                                                {
                                                  staticClass:
                                                    "!cursor-default !px-1.5 soli-round",
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-content",
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        {
                                                          staticClass:
                                                            "font-semibold soli-grey",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                    " +
                                                              _vm._s(
                                                                _vm
                                                                  .moment(
                                                                    item.starts_at
                                                                  )
                                                                  .format(
                                                                    "ddd, MMM D"
                                                                  )
                                                              ) +
                                                              "\n                                                "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-item-subtitle",
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              `${_vm
                                                                .moment(
                                                                  item.starts_at
                                                                )
                                                                .format(
                                                                  "h:mm A"
                                                                )} - ${_vm
                                                                .moment(
                                                                  item.ends_at
                                                                )
                                                                .format(
                                                                  "h:mm A"
                                                                )}`
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-item-subtitle",
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              `Musicologie ${item.location.name}`
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex items-center",
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-avatar",
                                                            {
                                                              staticClass:
                                                                "my-0 mr-2",
                                                              attrs: {
                                                                size: 28,
                                                              },
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src: item
                                                                    .teacher
                                                                    .profile_photo_path
                                                                    ? `/api/image-service/40x40/${item.teacher.profile_photo_path}`
                                                                    : item
                                                                        .teacher
                                                                        .profile_photo_url,
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(
                                                                    item.teacher
                                                                      .name
                                                                  ) +
                                                                  "\n                                                    "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("v-list-item-action", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex flex-col gap-2",
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          {
                                                            staticClass: "py-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                `${
                                                                  item.capacity -
                                                                  item.attending
                                                                } spot(s) left`
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            staticClass:
                                                              "shadow-orange",
                                                            attrs: {
                                                              small: "",
                                                              rounded: "",
                                                              color:
                                                                "secondary",
                                                              href: `/class-registration/${item.id}/edit`,
                                                            },
                                                          },
                                                          [_vm._v("Register")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }